var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 195,
    viewBox: "0 0 196 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_557_428)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_557_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 196,
    height: 195
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.52588e-05H195.5V195H0.5V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_557_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.644 87.6445H146.849",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.614 167.591V179.947C107.614 181.898 109.196 183.48 111.147 183.48H134.4",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.501 183.48H189.111C191.062 183.48 192.644 181.898 192.644 179.947V71.015C192.644 69.0635 191.062 67.4814 189.111 67.4814H157.094",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.977 87.6445H3.35645",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9771 67.4814H36.6978",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.596 67.4814H6.89017C4.93902 67.4814 3.35693 69.0635 3.35693 71.015V179.947C3.35693 181.898 4.93902 183.48 6.89017 183.48H84.8528C86.8044 183.48 88.3864 181.898 88.3864 179.947V167.591",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.709 56.1162H47.9033",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.697 32.796H51.9896C49.733 32.796 47.9033 34.6257 47.9033 36.8827V116.769",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.245 52.0757V36.8828C146.245 34.6259 144.416 32.7962 142.159 32.7962H126.666",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9033 130.871V162.869C47.9033 165.126 49.733 166.956 51.9899 166.956H142.158C144.415 166.956 146.245 165.126 146.245 162.869V73.792",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.569 117.534C101.836 116.055 99.4062 115.128 96.7063 115.12C94.0064 115.112 91.5704 116.025 89.8291 117.493",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6 104.55H112.634",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5146 104.55H81.5478",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.596 104.55H112.629",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4229 44.4316H62.4587",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4189 44.4316H62.454",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0605 44.4316H71.0956",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7021 44.4316H79.7372",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5858 44.4313L23.5029 51.5142",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5858 51.5146L23.5029 44.4318",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.584 40.8903L166.501 47.9731",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.584 47.9731L166.501 40.8903",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 11.5197L93.7856 18.6025",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 18.6025L93.7856 11.5197",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.271 63.1421C137.271 57.5165 141.831 52.9561 147.457 52.9561C153.083 52.9561 157.643 57.5165 157.643 63.1421C157.643 68.7678 153.083 73.3286 147.457 73.3286C141.831 73.3286 137.271 68.7678 137.271 63.1421Z",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.207 27.0972C110.207 22.1014 114.256 18.0518 119.252 18.0518C124.248 18.0518 128.297 22.1014 128.297 27.0972C128.297 32.0929 124.248 36.1426 119.252 36.1426C114.256 36.1426 110.207 32.0929 110.207 27.0972Z",
    stroke: "#3A3275",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_557_428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 195,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no-content.d47acb38f4b02404137d4957fe1ea250.svg";
export { ForwardRef as ReactComponent };